<template>
  <div>
    <div v-show="status==0">
      <div class="center flex flex-column align-items-center justify-content-center">
        <img src="@/assets/imgs/loan/apply/icon_face_verify.png" alt="">
        <span>请根据语音提示完成相应动作</span>
      </div>
      <!-- <div class="tips-imgs flex justify-content-between">
        <img src="@/assets/imgs/other/face-verify1.png" alt="">
        <img src="@/assets/imgs/other/face-verify2.png" alt="">
        <img src="@/assets/imgs/other/face-verify3.png" alt="">
        <img src="@/assets/imgs/other/face-verify4.png" alt="">
      </div> -->
    </div>
    <div class="verify-fail" v-show="status==3">
      <div class="center flex flex-column align-items-center justify-content-center">
        <img src="@/assets/imgs/loan/apply/icon_face_verify.png" alt="">
        <span>请根据语音提示完成相应动作</span>
      </div>
      <!-- <img src="@/assets/imgs/other/verify-fail0.png" alt="" class="fail">
      <h3>识别失败</h3>
      <p>请保持本人操作且正脸对框</p>
      <div class="img-list flex justify-content-between">
        <img src="@/assets/imgs/other/verify-fail1.png" alt="">
        <img src="@/assets/imgs/other/verify-fail2.png" alt="">
        <img src="@/assets/imgs/other/verify-fail3.png" alt="">
      </div> -->
    </div>
    <div class="btn-wrap flex flex-column justify-content-center">
      <div class="div_bottom_tips">
        <img src="@/assets/imgs/loan/apply/icon_face_verify_shield.png">
        <span>体验人脸识别，保障账户安全</span>
      </div>

      <input type="button" :value="status==3 ? '重新录制' : '开启录制'" class="lg-btn lg-btn-new" @click="startFace">
    </div>
    <div class="loading" v-show="status==1">
      <img src="@/assets/imgs/other/verifing.png" alt="">
      <h3>稍等片刻 验证中...</h3>
    </div>
    <div class="loading" v-show="status==2">
      <img src="@/assets/imgs/other/verify-success.png" alt="">
      <h3>验证成功</h3>
      <input type="button" value="进入下一步" class="lg-btn" @click="navigateToNext">
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {getH5KsToken} from '@/api';

  export default {
	data() {
	  return {
		fillStr: '', //上送身份信息所用的
		liveNode: '',
	  }
	},
	props: {
	  status: {
		type: [String, Number],
		default: 0 //0 录制状态；1验证中..//2验证成功 //3验证失败
	  },
	  nextPath: {
		type: String,
		default: '/verified-result' // /verified-result服务大厅进入实名认证完成跳转路径; /free-loan/bankcard-bind随心贷认证完成跳转页
	  }
	},
	computed: {
	  ...mapState(['freeLoanData', 'userInfo'])
	},
	created() {
	  let path = localStorage.getItem('verifyPath');
	  if (path === '/verified-result2') {
		this.liveNode = '实名认证';
	  } else if (path === '/free-loan/bankcard-bind') {
		this.liveNode = '申请流程';
	  }
	},
	methods: {

	  async geth5faceid() {
		let {freeLoanData, userInfo} = this;
		localStorage.setItem("freeLoanData", JSON.stringify(freeLoanData));//防止人脸识别回来freeLoanData变空
		localStorage.setItem("userInfo", JSON.stringify(userInfo));//防止人脸识别回来freeLoanData变空
		if (!freeLoanData.name || !freeLoanData.idNo) {
		  this.$toast("请先上传身份证正面照")
		  return;
		}
		getH5KsToken({
		  idNo: freeLoanData.idNo,
		  name: freeLoanData.name
		}).then(res => {
		  let result = JSON.parse(res.resJson);
		  if (result.token) {
			this.$emit('initEnterTime', new Date().getTime() / 1000);
			localStorage.setItem('faceBizId', result.biz_id);
			//打开H5活体页面，验证结果在VerifiedStep2.vue的activated判断
			location.href = 'https://qrcode.jmscf.com.cn/faceid/lite/do?token=' + result.token;
		  } else {
			this.$toast(result.error_message || '启动影像认证失败，请稍后重试')
		  }
		})
	  },

	  startFace() {
		this.geth5faceid()
	  },

	  navigateToNext() {
		this.$emit('navigateToNext')
	  }
	}
  }
</script>

<style lang="less" scoped>
  .center {
    img {
      width: 145px;
      margin: 100px 0 20px;
    }

    span {
      font-size: 14px;
      // font-weight: bold;
    }
  }

  .tips-imgs {
    padding: 59px 0 93px;

    img {
      width: 66px;
      height: 72px;
    }
  }

  .loading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    font-weight: bold;
    background: #fff;

    img {
      width: 183px;
      margin-bottom: 30px;
    }

    .lg-btn {
      margin-top: 159px;
    }
  }

  .verify-fail {
    padding: 0 44px;
    text-align: center;

    .img-list {
      padding: 35px 0 82px;

      img {
        width: 52.68px;
      }
    }

    h3 {
      font-size: 17px;
      font-weight: bold;
      padding-bottom: 14px;
    }

    .fail {
      width: 247px;
      margin: 61px 0 41px;
    }
  }

  .lg-btn-new {
    width: 100%;
    background: #D89A26;
    border-radius: 5px 5px 5px 5px;
    margin-top: 11px;
  }

  .div_bottom_tips {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 255px;

    img {
      width: 11px;
      height: 14px;
    }

    span {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #C7C7C7;
      margin-left: 3px;
    }
  }
</style>